import { Dispatch, SetStateAction } from "react";
import detectorWrapper from "./detector";
import { resetCorners } from "./scanViewUIHelper";
//---------------------------------------
// Exit and Cleanup
//---------------------------------------

export const cleanUp = (
  scanCaptureBuffer: any,
  setScanProgress: Dispatch<SetStateAction<number>>,
  videoRefBg: React.RefObject<HTMLVideoElement>,
  cardScanApi: any
) => {
  //kill timer

  //empty both detection buffer and clear progress UI
  scanCaptureBuffer.current = [];
  setScanProgress(0);

  //disable camera on exit
  if (videoRefBg && videoRefBg.current) {
    const videoBackground = videoRefBg.current;
    const stream = videoBackground.srcObject as MediaStream;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track: MediaStreamTrack) => track.stop());
      videoBackground.srcObject = null;
    }
  }

  detectorWrapper.cleanUp();

  if (cardScanApi?.current) {
    cardScanApi.current?.websocket.close();
    cardScanApi.current = null;
  }

  resetCorners();
};
